<template>
  <div
    class="card card-box"
    style="border-radius : 0%; min-height: 650px;"
  >
    <div class="card-body p-5" style="padding-top: 30px !important">
      <!-- Image Profile -->
      <div class="row">
        <div class="col-md-12">
          <h4 class="__blue mb-4">Tempat Praktik</h4>
        </div>
      </div>
      <!-- End Image Profile -->

      <!-- Infor Profile -->
      <div class="row">
        <div class="col-md-6">
          <b-form-group>
            <label for="">Nama Faskes</label>
            <b-form-input
              :disabled="true"
              type="text"
              maxlength="50"
              v-model="formProfile.nama"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group>
            <label for="">Kota / Kabupaten</label>
            <b-form-input
              :disabled="true"
              type="text"
              maxlength="50"
              v-model="formProfile.kota"
            ></b-form-input>
          </b-form-group>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-12">
              <b-form-group>
                <label for="">No. Telp Faskes</label>
                <b-form-input
                  :disabled="true"
                  type="text"
                  maxlength="50"
                  v-model="formProfile.handphone"
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-12">
              <b-form-group>
                <label for="">No. Whatsapp Faskes</label>
                <b-form-input
                  :disabled="true"
                  type="text"
                  maxlength="50"
                  v-model="formProfile.whatsapp"
                ></b-form-input>
              </b-form-group>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <b-form-group>
            <label for="">Alamat Faskes</label>
            <b-form-textarea
              v-model="formProfile.alamat"
              rows="5"
              max-rows="9"
              :disabled="true"
            ></b-form-textarea>
          </b-form-group>
        </div>
      </div>
      <!-- End Info Profile -->
    </div>
  </div>
</template>
<script>

import axios from "axios";
import { mapGetters } from "vuex";
import { EventBus } from "../../../event-bus";

export default {
  components: {},
  data() {
    return {
      formProfile: {
        nama: "",
        kota: "",
        handphone: "",
        whatsapp: "",
        alamat: ""
      },
    };
  },
  created() {
    this.getProfile();
  },
  mounted() {
  },
  computed: {
    ...mapGetters(["getKlinikId", "getRolesName"]),
    isPic() {
      return /pic/.test(this.getRolesName);
    }
  },
  watch: {},
  methods: {
    async getProfile() {
      try {
        let profile;

        profile = this.$store.state.user.id;

        const res = await axios.get(
          `${this.url_api}/klinik/user/${profile}?klinik_id=${this.getKlinikId}`
        );

        const { data } = res.data;
        const klinik = data.klinik_user[0].klinik

        this.formProfile = {
          nama: klinik.nama_klinik || '-',
          kota: klinik.kota_detail.nama || '-',
          handphone: klinik.nomor_telp || '-',
          whatsapp: klinik.nomor_wa || '-',
          alamat: klinik.alamat || '-'
        };
        EventBus.$emit('count-schedule', (0));
      } catch (error) {
        // console.log(error);
      }
    },
  }
};
</script>

<style scoped>
.__blue {
  color: #4b80b6;
}
.__icon_add_photo {
  position: absolute;
  top: 12px;
  left: 14px;
}
.__btn_add_photo {
  position: absolute;
  top: 85px;
  right: -20px;
  z-index: 20;
  border-radius: 50%;
  height: 44px !important;
  background-color: rgb(121, 121, 121);
}
.delete_photo {
  position: absolute;
  width: 100%;
  height: 20%;
  top: 30%;
  z-index: 9;
  font-size: 30pt;
  text-align: center;
}
.profile-custom {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  position: relative;
  border: 1px solid #cdcdcd;
}

.profile-custom img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}
</style>
